import get from 'lodash/get';
import {connect} from 'react-redux';
import without from 'lodash/without';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {saveResourceFieldAction} from 'resources/actions';
import {getBreakResource, extractResourceIdsWithPath} from 'utils/DBUtils';
import DecisionTree from './DecisionTree';

const mapStateToProps = (state, props) => {
  const masterBreakId = state.editBreak.break.MASTER;
  const masterBreak = state.resources.resources[masterBreakId];

  // the resource FormProxy gives us the path to the current step, which we use below to
  // create a path to the PQ answer that we want to modify.
  const personalityQuiz = props.formProxy.parentCurrentResource;

  return {
    masterBreak,
    personalityQuiz
  };
};

const mapDispatchToProps = {
  saveResourceFieldAction
};

// the resource field that we're modifying.
const fieldName = 'resultIds';

export default compose(
  setDisplayName('DecisionTreeContainer'),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {

    // returns the resourcePath to the PQ answer identified by `answerId`, as well as the
    // answer itself.
    const findPQAnswer = (answerId, questionId) => {
      const question = props.formProxy.parentCurrentResource.questions.find(q => q.id === questionId);

      const questionIndex = props.formProxy.parentCurrentResource.questions.indexOf(question);
      const answerIndex = question.answers.findIndex(a => a.id === answerId);

      const answerResourcePath = props.formProxy.parentPath().concat([
        //'personalityQuiz',
        `questions.${questionIndex}`,
        `answers.${answerIndex}`
      ]);

      const answer = get(props.masterBreak, answerResourcePath.join('.'));

      return {
        answer,
        answerResourcePath
      };
    };

    // an object that maps PQ question ids to objects that map PQ result ids each to a
    // list of PQ answer ids, for indicating which PQ answers are associated with a given
    // PQ result, indexed by PQ question.
    //
    // it looks like this:
    // {
    //   [questionId]: {
    //     [resultId]: [...answerIds]
    //   }
    // }
    const chosenResults = props.formProxy.parentCurrentResource.questions.reduce((results, question) => {
      results[question.id] = {};

      for (const answer of question.answers) {
        for (const resultId of (answer.resultIds || [])) {
          results[question.id][resultId] = (results[question.id][resultId] || []).concat(answer.id);
        }
      }

      return results;
    }, {});

    // save call for toggling a single result for a given answer.
    const toggleResult = (resultId, answerId, questionId, {select = true}) => {
      const {answer, answerResourcePath} = findPQAnswer(answerId, questionId);
      const resultIds = (answer.resultIds || []).filter((resultId) =>
          // filter out results that may not exist anymore
          props.formProxy.parentCurrentResource.results.findIndex(result => result.id === resultId) !== -1
      );

      // if selecting, pass all current result ids for this answer, plus the new one being
      // selected. if clearing a given result, pass the list of current result ids for
      // this answer minus the one being cleared.
      const value = select === true ? resultIds.concat(resultId) : without(resultIds, resultId);

      props.saveResourceFieldAction(
        answer.resourceId,
        props.masterBreak.resourceId,
        answerResourcePath,
        answerResourcePath.concat(fieldName),
        fieldName,
        value,
        extractResourceIdsWithPath(props.masterBreak, props.masterBreak, answerResourcePath)
      );
    };

    // save call for toggling all available results for a given answer.
    const toggleAllResults = (answerId, questionId, {select = true}) => {
      const {answer, answerResourcePath} = findPQAnswer(answerId, questionId);

      // if selecting, pass all result ids as the value, otherwise pass the empty list.
      const value = select === true ? props.formProxy.parentCurrentResource.results.map(({id}) => id) : [];

      props.saveResourceFieldAction(
        answer.resourceId,
        props.masterBreak.resourceId,
        answerResourcePath,
        answerResourcePath.concat(fieldName),
        fieldName,
        value,
        extractResourceIdsWithPath(props.masterBreak, props.masterBreak, answerResourcePath)
      );
    };

    return {
      chosenResults,

      selectResult: (...args) => toggleResult(...args, {select: true}),
      clearResult: (...args) => toggleResult(...args, {select: false}),

      selectAll: (...args) => toggleAllResults(...args, {select: true}),
      clearAll: (...args) => toggleAllResults(...args, {select: false})
    };
  })
)(DecisionTree);



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DecisionTree/DecisionTreeContainer.js